<template>
    <v-row class="ma-0">
        <v-col v-if="showGraphs" cols="12" class="pa-0">
            <v-sheet :class="xs?'card-dialogs-graph-wop':'card-dialogs-graph'" class="mb-4" color="bgtopology">
                <SingleChart v-if="finalItemBandWidth.length !== 0" :name="'Ancho Banda'" :first-array="finalItemBandWidth" title="Ancho de Banda" :color="COLOR.single"/>
                <v-sheet v-else class="text-center" color="transparent">
                    <Prog_circular />
                </v-sheet>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">

import { ref, onMounted } from 'vue';  

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();


/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore }   from 'vuex';
const store  = useStore();

/********************************
 *********** SERVICES ***********
 *******************************/
import { getBandWidthDataByIp } from '@/services/RAOS/Graphs';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';


/********************************
 ********** COMPONENTS **********
 *******************************/
import SingleChart from '@/components/SmartLink/charts/SingleChart.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

const props = defineProps({
    title   :{ required:true },
    ip      :{ required:true, type:String },
}) 


const showGraphs    = ref(false); 


const finalItemBandWidth  = ref();

async function getAllBandWidthByIP() {

    
    const params = {
        ip : props.ip
    }
    const allData = await getBandWidthDataByIp(params)

    if( allData.status === 400 ){
        showGraphs.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showGraphs.value = allData.showGraphs        
        finalItemBandWidth.value = allData.data
    }

}


onMounted( async() => {
    getAllBandWidthByIP();
    console.log('RAOS BANDWIDTH MOUNTED')
})

</script>
